<template>
  <div id="login" class="flex-center">
    <div class="logo">
      <img src="../assets/images/lx_website_logo.png" alt="">
    </div>
    <div class="login-content flex-h-center">
      <div class="login-form">
        <div class="tab-bar">
          <ul class="flex-h-center">
            <li :class="currentIndex===index?'active':''" v-for="(item,index) in tabList" :key="index"
              @click="tabChange(index)">{{item}}</li>
          </ul>
          <span class="return-home" @click="$router.push('/index')">返回首页</span>
        </div>
        <div class="form-bar">
          <div class="form-bar-content flex-v-center">
            <p>账号</p>
            <div class="form-input type-a flex-h-center">
              <input type="text" v-model="postForm.account" placeholder="请输入账号" />
              <p class="tip-title" v-if="loginCheckAccount && !postForm.account">*请输入账号</p>
            </div>
          </div>
          <div class="form-bar-content flex-v-center">
            <p>密码</p>
            <div class="form-input type-p flex-h-center">
              <input type="password" v-model="postForm.password" placeholder="请输入密码" />
              <p class="tip-title" v-if="loginCheckPassword && !postForm.password">*请输入密码</p>
            </div>
          </div>
          <div class="form-remenber">
            <input type="checkbox" @change="inputChange" :checked="checked" />
            <span>记住密码</span>
            <p class="tip-title" v-if="errorDesc">{{errorDesc}}</p>
          </div>
          <div class="form-read">
            <input type="checkbox" @change="inputReadChange" v-model="isRead" />我已阅读并同意 <a class="readbook" href="http://www.lanxinghudong.com/office/%E6%8F%BD%E6%98%9F%E5%AE%A2%E6%88%B7%E6%9C%8D%E5%8A%A1%E6%9D%A1%E6%AC%BE.html" target="_blank">揽星互动服务条款</a>
            <p v-if="isTiped" class="tip-title">*阅读并同意 《揽星互动服务条款》</p>
          </div>
          <div class="login-button" @click="login">
            <span v-if="isLoading" class="loading"></span>
            {{isLoading?'登录中，请稍后':'登录'}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Store from "../utils/Store.js";
  import {
    advertiserPostLogin,
    mediaPostLogin
  } from "../api/login";
  import {
    setPageLoginReffer
  } from '../utils/auth';
  export default {
    data() {
      return {
        tabList: ["广告主登录", "媒体登录"],
        currentIndex: 0,
        formIndex: 0,
        focuslist: ["账号", "密码"],
        postForm: {},
        isLoading: false,
        loginCheckAccount: false,
        loginCheckPassword: false,
        tolink: "",
        errorDesc: "",
        store_key_ad: {},
        store_key_mj: {},
        checked: false,
        isRead: false,
        isTiped: false
      };
    },
    methods: {
      tabChange(value) {
        this.currentIndex = value;
        if (value === 0) {
          this.checked = this.store_key_ad.account;
          this.postForm = this.store_key_ad;
          return;
        }

        if (value === 1) {
          this.checked = this.store_key_mj.account;
          this.postForm = this.store_key_mj;
          return;
        }
        this.postForm = {};
      },
      inputChange(e) {
        if (e.target.checked) {
          let key = ["guanggaozhu", "meiti"];
          Store.set(key[this.currentIndex], JSON.stringify(this.postForm));
        }
      },
      inputReadChange(val) {
        if (this.isTiped && val) {
          this.isTiped = false;
        }

      },
      login() {
        console.log(this.isRead)
        if (!this.isRead) return this.isTiped = true;
        if (this.postForm.account && this.postForm.password) {
          this.isLoading = true;
          setPageLoginReffer('web_yt');
          if (this.currentIndex === 0) {
            advertiserPostLogin(this.postForm).then(res => {
              if (res.errorDesc) {
                this.errorDesc = res.errorDesc;
                this.isLoading = false;
                return;
              }
              const accountType = res.returnValue.accountType;
              this.isLoading = false;
              let toLink_agen =
                process.env.NODE_ENV === "production" ?
                "http://advertiser.lanxinghudong.com/agen/index.html#/login/index" :
                "http://mingz-dev.admingzhi.com/agen/index.html#/login/index";
              let toLink_ad =
                process.env.NODE_ENV === "production" ?
                "http://advertiser.lanxinghudong.com/dsp/index.html#/login" :
                "http://mingz-dev.admingzhi.com/dsp/index.html#/login";
              let toLink = accountType === 1 ? toLink_agen : toLink_ad;
              this.tolink = `${toLink}?aviodid=${res.returnValue.token}&reffer=web_yt`;
              location.href = this.tolink;
            });
          } else {
            mediaPostLogin(this.postForm).then(res => {
              if (res.errorDesc) {
                this.errorDesc = res.errorDesc;
                this.isLoading = false;
                return;
              }
              this.errorDesc = "";
              this.isLoading = false;
              let toLink =
                process.env.NODE_ENV === "production" ?
                "http://advertiser.lanxinghudong.com/media/index.html#/login/index" :
                "http://mingz-dev.lanxinghudong.com/media/index.html#/login/index";
              this.tolink = `${toLink}?aviodid=${res.returnValue.token}&reffer=web_yt`;
              location.href = this.tolink;
              // // 解决a标签自动跳转
              // if (this.$refs.tolink) {
              //   setTimeout(() => {
              //     this.$refs.tolink.click();
              //     setTimeout(() => {
              //       location.reload();
              //       this.$refs.tolink = null;
              //     }, 30);
              //   }, 10);
              // }
            });
          }
        } else {
          this.loginCheckPassword = !this.postForm.password;
          this.loginCheckAccount = !this.postForm.account;
        }
      }
    },
    created() {
      this.store_key_ad = JSON.parse(Store.get("guanggaozhu") || "{}");
      this.store_key_mj = JSON.parse(Store.get("meiti") || "{}");
      this.checked = this.store_key_ad.account;
      if (this.store_key_ad) {
        this.postForm = this.store_key_ad;
      }
      if (this.$route.query.login) {
        this.currentIndex = this.$route.query.login === "media" ? 1 : 0;
        this.tabChange(this.currentIndex);
      }
    }
  };
</script>

<style lang='scss' scoped>
  #login {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: url(../assets/images/login-bg.png) no-repeat;
    background-size: cover;

    .logo {
      margin-bottom: 20px;

      img {
        width: 258px;
        height: 43px;
      }
    }

    .login-logo {
      width: 380px;
      height: 419px;
      background: url(../assets/images/login-bg-b.png) no-repeat;
      background-size: cover;

      img {
        width: 155px;
        height: 130px;
      }
    }

    .login-form {
      width: 716px;
      height: 495px;
      background: rgba(255, 255, 255, 1);
      padding: 36px 21px;
      box-sizing: border-box;

      .tab-bar {
        position: relative;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(139, 139, 139, 1);
        text-align: center;
        .return-home{
          position: absolute;
          top:-5px;
          right: 60px;
          display: inline-block;
          color: #ffffff;
          background: #001c6f;
          font-size: 14px;
          padding: 8px;
          border-radius: 8px;
          cursor: pointer;
        }

        ul {
          display: flex;
          justify-content: flex-start;
          width: 557px;
          margin: 0 auto;
          border-bottom: 1px solid rgba(151, 151, 151, 0.5);
        }

        li {
          cursor: pointer;
          width: 112px;
          height: 32px;
          line-height: 32px;
          display: inline-block;
          text-align: center;
          margin-right: 30px;

          &.active {
            border-bottom: 4px solid rgba(245, 145, 54, 1);
          }
        }

        li:nth-child(2) {
          margin-right: 0;
        }
      }

      .form-bar {
        margin-top: 28px;

        .form-bar-content {
          margin-bottom: 22px;

          p {
            width: 557px;
            text-align: left;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(139, 139, 139, 1);
            margin-bottom: 7px;
          }

          .form-input {
            position: relative;
            width: 557px;
            height: 55px;
            border-radius: 6px;
            opacity: 0.68;
            font-size: 14px;
            box-sizing: border-box;

            input {
              width: 557px;
              height: 55px;
              border-radius: 6px;
              padding-left: 38px;
              box-sizing: border-box;
              border: 1px solid rgba(151, 151, 151, 1);

              &:focus {
                border: 1px solid rgba(23, 32, 40, 1);
              }
            }

            .tip-title {
              position: absolute;
              bottom: -25px;
              font-size: 12px;
              color: red;
            }
          }

          .form-input::after {
            position: absolute;
            top: 21px;
            left: 12px;
            content: "";
            width: 18px;
            height: 18px;
            background-size: cover;
          }

          .type-a::after {
            background: url(../assets/images/icon-acount-active.png) no-repeat;
          }

          .type-p::after {
            background: url(../assets/images/icon-pass-active.png) no-repeat;
          }
        }

        .form-remenber {
          position: relative;
          display: flex;
          align-items: center;
          margin-top: 20px;
          margin-left: 60px;

          input {
            border-radius: 2px;
            border: 1px solid rgba(151, 151, 151, 1);
          }

          span {
            margin-left: 8px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(139, 139, 139, 1);
          }

          .tip-title {
            position: absolute;
            bottom: -25px;
            font-size: 12px;
            color: red;
          }
        }

        .form-read {
          text-align: center;
          position: relative;
          margin-top: 25px;

          input {
            margin-right: 6px;
          }

          .tip-title {
            position: absolute;
            bottom: -25px;
            left: 30%;
            font-size: 12px;
            color: red;
            animation: textShake 0.35s 3;

            @keyframes textShake {
              0% {
                transform: translateY(0);
              }

              100% {
                transform: translateY(-8px);
              }
            }
          }
        }

        .login-button {
          cursor: pointer;
          width: 411px;
          height: 60px;
          background: RGBA(0, 28, 111, 1);
          border-radius: 13px;
          line-height: 60px;
          text-align: center;
         font-size: 21px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          margin: 0 auto;
          margin-top: 35px;
          display: flex;
          align-items: center;
          justify-content: center;

          .loading {
            display: inline-block;
            width: 15px;
            height: 15px;
            background: url(../assets/images/loading.png) no-repeat;
            background-size: cover;
            margin-right: 10px;
            animation: rotating 2s linear infinite;
          }

          @keyframes rotating {
            0% {
              transform: rotate(0deg);
            }

            100% {
              transform: rotate(1turn);
            }
          }
        }
      }
    }
  }

  /*包含以下四种的链接*/
  a {
    text-decoration: none;
    color: white;
  }

  /*正常的未被访问过的链接*/
  a:link {
    text-decoration: none;
  }

  /*已经访问过的链接*/
  a:visited {
    text-decoration: none;
  }

  /*鼠标划过(停留)的链接*/
  a:hover {
    text-decoration: none;
  }

  /* 正在点击的链接*/
  a:active {
    text-decoration: none;
  }
  .readbook{
    cursor: pointer;
    color: rgba(245, 145, 54, 1);
  }
</style>